const aa = require("./dist/search-insights-browser.cjs.min.js");

module.exports = aa.default;
Object.keys(aa).forEach(key => {
  if (key !== "default") {
    module.exports[key] = aa[key];
  }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/search-insights/index-browser.cjs.js
// module id = 329
// module chunks = 0